module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8679/img/mobile-onboarding-powering-up.svg"